import React from "react";
import ReactDOM from "react-dom";

const Loader = ({ message = "KAVIRAJ AGENCIES" }) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-white/90 backdrop-blur-md">
      <div className="relative flex flex-col items-center">
        {/* Animated Rings */}
        <div className="relative w-24 h-24 mb-6">
          <div className="absolute inset-0 border-4 border-blue-100 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
          <div className="absolute inset-4 border-4 border-indigo-100 rounded-full"></div>
          <div className="absolute inset-4 border-4 border-indigo-500 rounded-full border-b-transparent animate-spin-slow"></div>
        </div>

        {/* Company Name with Pulse Effect */}
        <div className="text-center">
          <h2 className="text-xl font-black text-[#1e293b] tracking-widest animate-pulse mb-1">
            {message}
          </h2>
          <div className="flex justify-center space-x-1">
            <div className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-1.5 h-1.5 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
          <p className="text-[10px] font-bold text-gray-400 mt-4 uppercase tracking-[0.3em]">
            Fueling Excellence
          </p>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(-360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }
      `}} />
    </div>,
    document.body
  );
};

export default Loader;
